import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dialog: {
    [theme.breakpoints.up('md')]: {
      width: 600,
      maxWidth: 600
    }
  },
  contentDialog: {
    [theme.breakpoints.up('md')]: {
      width: '90%'
    }
  },
  initialMessageContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    minHeight: 220,
    marginBottom: theme.spacing(4)
  },
  messageContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  alertContainer: {
    display: 'flex',
    alignItems: 'flex-start',

    '& svg': {
      flexShrink: 0,
      marginTop: theme.spacing()
    },
    backgroundColor: '#D9D9D9',
    padding: theme.spacing(2, 2.5)
  },
  alertParagraph: {
    color: '#FF4B4B',
    fontWeight: 500,
    alignItems: 'center',
    fontSize: '1rem',
    marginLeft: theme.spacing(1)
  },
  welcomeMessage: {
    fontWeight: 500,
    fontSize: '1rem',
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-wrap',
    textAlign: 'justify',
    '& a': {
      fontWeight: 500,
      color: '#4285F4'
    }
  },
  button: {
    width: 250,
    height: 46,
    alignSelf: 'center',
    borderRadius: 10,
    '& span': {
      fontSize: '1rem'
    }
  },
  text: {
    color: theme.palette.primary.main,
    fontWeight: 500,

    '& a': {
      color: theme.palette.primary.main
    }
  }
}))
